import type { Distance, Pixel, SpatialRectangle } from "@pdfking/math"
import type { HorizontalAlign } from "../align/HorizontalAlign"
import type { VerticalAlign } from "../align/VerticalAlign"
import type { ConcretePlotObject } from "./BasePlotObject"
import type { PlotFunction } from "./PlotFunction"

// Specific type for plot_text
export type PlotText = {
  enum: PlotFunction.PLOT_TEXT
  font_name: string
  font_size: Pixel
  horizontal_align: HorizontalAlign
  position: SpatialRectangle<Distance>
  text: string
  text_color: string
  vertical_align: VerticalAlign
} & ConcretePlotObject
